import React from 'react'
import './styles.css'
import BackgroundComponent from '../BackgroundComponent'

export default function HomeSectionComponent() {
  return (
    <>
      <BackgroundComponent />
    </>
  )
}
